export default __webpack_public_path__ + "static/media/memories.9cfa8a46.png";